// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accountContainer {
  width: 100%;
  /* height: 100vh; */
  display: flex;
  flex-direction: column;
  /*align-items: center;*/
  justify-content: flex-start;
  /* padding: 40px; */
  background-color: #ebebeb;
}

.accountInfoContainer {
  /* border: 1px solid #ccc; */
  border-radius: 5px;
  width: 92%;
  /* height: 70vh; */
  margin: auto;
  padding: 20px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/pages/yacht/home/payment-account/PaymentAccount.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB","sourcesContent":[".accountContainer {\n  width: 100%;\n  /* height: 100vh; */\n  display: flex;\n  flex-direction: column;\n  /*align-items: center;*/\n  justify-content: flex-start;\n  /* padding: 40px; */\n  background-color: #ebebeb;\n}\n\n.accountInfoContainer {\n  /* border: 1px solid #ccc; */\n  border-radius: 5px;\n  width: 92%;\n  /* height: 70vh; */\n  margin: auto;\n  padding: 20px;\n  margin-bottom: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
